import { memo } from "react";
import { StyleSheet } from "react-native-unistyles";
import Animated, { type AnimatedStyle } from "react-native-reanimated";
import type { ViewStyle } from "react-native";
import { VideoControlButton } from "./VideoControlButton";

type AnimatedMuteButtonProps = {
  isMuted: boolean;
  isFullscreen: boolean;
  controlsVisible: boolean;
  animatedStyle: AnimatedStyle<ViewStyle>;
  onPress: () => void;
};

export const AnimatedMuteButton = memo(
  ({ isMuted, isFullscreen, controlsVisible, animatedStyle, onPress }: AnimatedMuteButtonProps) => {
    return (
      <Animated.View
        style={[styles.container, animatedStyle]}
        pointerEvents={controlsVisible || isFullscreen ? "auto" : "none"}
      >
        <VideoControlButton
          icon={isMuted ? "volumeOff" : "volumeOn"}
          size="small"
          onPress={onPress}
          accessibilityLabel={isMuted ? "Unmute audio" : "Mute audio"}
        />
      </Animated.View>
    );
  },
);

const styles = StyleSheet.create((theme) => ({
  container: {
    position: "absolute",
    bottom: theme.spacing.lg,
    left: theme.spacing.lg,
    zIndex: 10000,
  },
}));
